let keyboardLast = false;
let watching = false;

/** Starts noting whether the editor's latest input was a key press or a pointer press. */
export function watchInputModality() {
  if (watching || typeof document === "undefined") return;
  watching = true;
  document.addEventListener("keydown", () => (keyboardLast = true), true);
  document.addEventListener("pointerdown", () => (keyboardLast = false), true);
}

export function lastInputWasKeyboard(): boolean {
  return keyboardLast;
}
